module.exports = __webpack_public_path__ + "img/feature-icon-5.085f9688.svg";